var map = {
	"./20ideas.svg": 561,
	"./away.svg": 563,
	"./bookmark-a11y.svg": 564,
	"./bookmark-active-a11y.svg": 565,
	"./bookmark-active.svg": 566,
	"./bookmark.svg": 567,
	"./calendar.svg": 568,
	"./card-blue.svg": 569,
	"./card-green.svg": 570,
	"./card-red.svg": 571,
	"./card.svg": 572,
	"./check-big.svg": 573,
	"./check-small.svg": 574,
	"./check.svg": 575,
	"./checkmark.svg": 576,
	"./chevron-2.svg": 577,
	"./chevron-24-right.svg": 578,
	"./chevron-right-a11y.svg": 579,
	"./chevron-right.svg": 580,
	"./chevron.svg": 581,
	"./close-2.svg": 582,
	"./close-3.svg": 583,
	"./close-a11y.svg": 584,
	"./close-circle.svg": 585,
	"./close.svg": 586,
	"./copy-a11y.svg": 587,
	"./copy.svg": 588,
	"./corner-right.svg": 589,
	"./corner-top.svg": 590,
	"./crown.svg": 591,
	"./dots-column.svg": 592,
	"./dots.svg": 593,
	"./download.svg": 594,
	"./edit.svg": 595,
	"./email.svg": 596,
	"./enter.svg": 597,
	"./eye-a11y.svg": 598,
	"./eye-close.svg": 599,
	"./eye-open.svg": 600,
	"./eye.svg": 601,
	"./filter.svg": 602,
	"./gallery-a11y.svg": 603,
	"./gallery.svg": 604,
	"./info.svg": 605,
	"./list.svg": 606,
	"./lock.svg": 607,
	"./logo.svg": 608,
	"./marusia-vk.svg": 609,
	"./minus.svg": 610,
	"./mir.svg": 611,
	"./news.svg": 612,
	"./next.svg": 613,
	"./pause-large.svg": 614,
	"./pause.svg": 615,
	"./philips.svg": 616,
	"./pin.svg": 617,
	"./play-big.svg": 618,
	"./play-large.svg": 619,
	"./play.svg": 620,
	"./plus-one.svg": 621,
	"./plus.svg": 622,
	"./profile-bookmark.svg": 623,
	"./profile-info.svg": 624,
	"./profile-logout.svg": 625,
	"./profile-notifications.svg": 626,
	"./profile-subscription.svg": 627,
	"./promo.svg": 628,
	"./restart.svg": 629,
	"./rewind.svg": 630,
	"./rustore.svg": 631,
	"./salut-speech.svg": 632,
	"./search.svg": 633,
	"./share-a11y.svg": 634,
	"./share.svg": 635,
	"./shield.svg": 636,
	"./sort.svg": 637,
	"./speed-1.5x.svg": 638,
	"./speed-1x.svg": 639,
	"./switch-big.svg": 640,
	"./switch.svg": 641,
	"./volume-fill.svg": 642,
	"./volume-full.svg": 643,
	"./volume-half.svg": 644,
	"./volume-off.svg": 645,
	"./wifi-bestEmployers.svg": 646,
	"./wifi-default.svg": 647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 560;